import { GetTimezonesRequestParams } from '@/hooks/useApi/useActiveManagementApi/types'
import { ActiveManagementTimezonesFiltersValues } from '@/utils/constants'
import { toArrayQueryParams } from '@/utils/toArrayQueryParams'

export const mapActiveManagementTimezonesQueryParams = (
    filters: ActiveManagementTimezonesFiltersValues
): GetTimezonesRequestParams => {
    return {
        'facilityIds[]': toArrayQueryParams(filters.facility),
        'nodeIds[]': toArrayQueryParams(filters.node),
        'tagIds[]': toArrayQueryParams(filters.tag),
    }
}
